import { render, staticRenderFns } from "./goodOrderList.vue?vue&type=template&id=3a1d97c3&scoped=true&"
import script from "./goodOrderList.vue?vue&type=script&lang=js&"
export * from "./goodOrderList.vue?vue&type=script&lang=js&"
import style0 from "./goodOrderList.vue?vue&type=style&index=0&id=3a1d97c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1d97c3",
  null
  
)

export default component.exports